import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const MiniSplash = dynamic(() => import('./MiniSplash'));

Builder.registerComponent(MiniSplash, {
	name: 'MiniSplash',
	inputs: [
		{
			name: 'backgroundImage',
			friendlyName: 'Background Image',
			type: 'file',
			allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif'],
			required: true,
			helperText: 'Select an image to use as the background',
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: 'transparent',
			helperText:
				'Select a background color to show behind the image. Ensure image has transparent background.',
		},
		{
			name: 'mobileBackgroundImage',
			friendlyName: 'Mobile Background Image',
			type: 'file',
			allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif'],
			required: false,
		},
		{
			name: 'shouldContain',
			friendlyName: 'Contain Image',
			type: 'boolean',
			defaultValue: false,
			helperText: 'When enabled, ensures the image fits within the component without overflowing',
		},
		{
			name: 'height',
			friendlyName: 'Height',
			type: 'number',
			defaultValue: 200,
			helperText: 'Height in pixels of splash',
		},
		{
			name: 'mobileHeight',
			friendlyName: 'Mobile Height',
			type: 'number',
			defaultValue: 200,
			helperText: 'Height in pixels of splash on mobile',
		},
	],
	image: getIconUrl(Icon.IMAGE),
});
